import React from "react";
import { DollarSign, Users, Luggage } from "lucide-react";

export default function CamionetaCard({ titulo, imagen, capacidad }) {
  return (
    <div className="flex justify-center py-8 bg-primary-50">
      <div className="max-w-5xl border border-primary-800 shadow-lg rounded-2xl overflow-hidden p-6 grid md:grid-cols-2 gap-6 items-center">
        {/* Imagen del vehículo */}
        <div className="flex justify-center">
          <div className="relative w-[380px] h-[260px] rounded-full overflow-hidden border-4 border-yellow-400 shadow-md">
            <img
              src={imagen}
              alt={titulo}
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Información */}
        <div className="text-center md:text-left">
          <h2 className="text-2xl font-bold text-yellow-500 mb-4">{titulo}</h2>

          <div className="space-y-3">
            <div className="flex items-center gap-3">
              <DollarSign className="text-black w-6 h-6" />
              <p className="text-lg font-semibold">
                ¡Mejores precios! / Best prices!
              </p>
            </div>

            <div className="flex items-center gap-3">
              <Users className="text-black w-6 h-6" />
              <p className="text-lg font-semibold">
                {capacidad} Pasajeros / Passengers
              </p>
            </div>

            <div className="flex items-center gap-3">
              <Luggage className="text-black w-6 h-6" />
              <p className="text-lg font-semibold">
                {capacidad} Maletas / Luggages
              </p>
            </div>
          </div>

            <a
                href="https://api.whatsapp.com/send?phone=51959605254&text=Estoy%20Interesado%20en%20los%20Tours%20que%20Ofrece"
                target="_blank"
                rel="noopener noreferrer"
                >
                <button className="mt-6 bg-yellow-500 hover:bg-yellow-600 text-black font-bold text-base shadow-md px-6 py-3 rounded-lg transition-all">
                    ¡Reserva ya! ¡Paga en Cusco! / "Book now! Pay in Cusco!"
                </button>
            </a>
        </div>
      </div>
    </div>
  );
}